import { Check, Copy, Download } from 'lucide-react'
import { useState } from 'react'
import { Button, Checkbox } from '@/components/ui'
import { BLOCK_AREA } from '@/lib/analytics'
import { t } from '@/lib/i18n'
import { copyText, recoveryCodesFile } from './api'

function downloadText(name: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }))
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** The 10 recovery codes, shown once: copy, download, and "I saved them" before Done. */
export function RecoveryCodes({ codes, account, onDone }: { codes: string[]; account: string; onDone: () => void }) {
  const [saved, setSaved] = useState(false)
  return (
    <div className="space-y-4" data-testid="mfa-setup-codes" {...BLOCK_AREA}>
      <div className="space-y-1">
        <p className="text-body font-semibold text-text">{t('Save your recovery codes')}</p>
        <p className="text-meta text-muted">
          {t('If you lose your phone, each of these codes lets you in once. We show them only now, so keep them somewhere safe like a password manager.')}
        </p>
      </div>
      <ul
        className="grid grid-cols-2 gap-2 rounded-card border border-line bg-surface-2 p-4 font-mono text-body text-text"
        aria-label={t('Recovery codes')}
        data-testid="mfa-recovery-codes"
      >
        {codes.map((c) => <li key={c}>{c}</li>)}
      </ul>
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" variant="secondary" leftIcon={<Copy />} onClick={() => void copyText(codes.join('\n'), t('Recovery codes copied'))}>
          {t('Copy codes')}
        </Button>
        <Button
          type="button"
          size="sm"
          variant="secondary"
          leftIcon={<Download />}
          onClick={() => downloadText('mg-ai-school-recovery-codes.txt', recoveryCodesFile(codes, account))}
        >
          {t('Download')}
        </Button>
      </div>
      <Checkbox checked={saved} onCheckedChange={(v) => setSaved(v === true)} label={t('I saved my recovery codes')} />
      <div className="flex justify-end">
        <Button type="button" disabled={!saved} leftIcon={<Check />} onClick={onDone}>
          {t('Done')}
        </Button>
      </div>
    </div>
  )
}
